import { atom } from 'recoil';

const uid = atom<string>({
  key: '',
  default: '',
});

export default uid;
